// Central data-testid registry (kept lightweight)
export const HOME = {
  hireCta: "home-hire-cta",
  servicesCta: "home-services-cta",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkServices: "nav-link-services",
  linkContact: "nav-link-contact",
  hireCta: "nav-hire-cta",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const WA = {
  button: "whatsapp-float-button",
};

export const CONTACT = {
  form: "contact-form",
  fullName: "contact-full-name",
  email: "contact-email",
  phone: "contact-phone",
  role: "contact-role",
  company: "contact-company",
  service: "contact-service",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};
